export const initialSettings = {
  webhooks: [
    {
      id: 1,
      url: "https://api.yourcompany.com/webhooks/orbit",
      events: ["All Events"],
      status: "active"
    }
  ],
  notifications: {
    integrationErrors: true,
    workflowCompletions: true,
    rateLimitWarnings: true,
    securityAlerts: true
  },
  security: {
    twoFactorEnabled: false,
    ipAllowlistConfigured: false
  },
  dataRetention: {
    activityLog: "30 days",
    webhookEvents: "7 days"
  }
};
